import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Version } from '../../../modules/models/version';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { TranslateService } from 'ng2-translate';
import { IMyOptions, IMyDateModel } from 'mydatepicker';

import { ProjectsService } from '../services/projects.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';
import { InlineEditorService } from '../../../shared/services/inline-editor.service';
import { Util } from '../../../shared/util';

import { Sprint, Story } from '../../models';
import { Constants } from '../../../app.const';

declare var $: any;

@Component({
  selector: 'app-modal-delete-version',
  templateUrl: './modal-delete-version.component.html',
})
export class ModalDeleteVersionComponent implements OnInit {

  @ViewChild('versionName') element: ElementRef;

  private showItem: any = [];
  private versionList: any = [];
  @Input() projectId: number;
  version: Version = new Version();
  versionForm: FormGroup;
  isSubmit: boolean = false;

  isDeleteConfirm: Array<boolean> = [];
  trasparent: boolean = false;

  release_date: any;
  private constants = Constants;
  private releaseDateOptions: IMyOptions = {
      dateFormat: this.constants.dateFormatDatepicker,
      selectionTxtFontSize: '14px',
      editableDateField: false,
      disableUntil: {year: 2016, month: 8, day: 10},
  };

  constructor(
    private formBuilder: FormBuilder,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,
    private inlineEditorService: InlineEditorService
  ) {
    this.initVersionForm();
    this.showItem = this.versionList.map(i => false);
  }

  ngOnInit() {
    this.initVersionForm();
    // disable the past dates for release date
    let currentData = new Date();
    let year = currentData.getFullYear();
    let month = currentData.getMonth()+1;
    let day = currentData.getDate();
    
    this.releaseDateOptions.disableUntil.year = year;
    this.releaseDateOptions.disableUntil.month = month;
    this.releaseDateOptions.disableUntil.day = day-1;
  }

  initVersionForm() {
    this.isSubmit = false;
    this.versionForm = this.formBuilder.group({
      version_label: ['', Validators.required],
      release_date: ['', Validators.required]
    });
  }

  resetVersionForm(){
    this.versionForm.reset();
    this.isSubmit = false;
    this.release_date = Util.getDateObject();
  }

  loadProjectVersions() {
    this.initVersionForm();
    this.release_date = Util.getDateObject();
    this.projectsService.getProjectVersion(this.projectId.toString()).subscribe(
      result => {
        this.versionList = result.data;
      });
  }

  openDeleteConfirmFrom(version){
    this.trasparent = true;
    this.isDeleteConfirm[version.id] = true;
  }

  doConfirmeDelete(event, version){
    if(event){
      this.deleteVersions(version.id);
    }
    this.trasparent = false;
    this.isDeleteConfirm[version.id] = false;
  }

  deleteVersions(versionId) {
    this.projectsService.deleteProjectVersions(this.projectId, versionId).subscribe(
      result => {
        //this.alertService.success({ title: "", msg: this.translate.instant("DELETE_VERSION") });
        this.alertService.success({ title: "", msg: result.message});
        this.loadProjectVersions();
        this.showItem = this.versionList.map(i => false);
      }, error => {
        this.alertService.success({ title: "", msg: 'Error' })
      });
  }
  deleteVersionApi(res) {
    if (res.status) {
      this.projectsService.deleteProjectVersions(this.projectId.toString(), res.data.id).subscribe(
        result => {
          this.alertService.success({ title: "", msg: this.translate.instant("DELETE_VERSION") });
          this.loadProjectVersions();
          this.showItem = this.versionList.map(i => false);
        }, error => {

        });
    }
  }

  saveChangesVersion() {
    this.isSubmit = true;
    if (this.versionForm.valid) {
      this.version.release_date = this.release_date.formatted;
      this.projectsService.createProjectVersion(this.version, this.projectId).subscribe(
        version => {
          this.versionList.push(version.data);
          this.resetVersionForm();
          // this.alertService.success({ title: "", msg: this.translate.instant("CREATE_VERSION") });
          this.alertService.success({ title: "", msg: version.message });
        },
        error=>{
          this.isSubmit = false;
        }
      );
    }
  }

  editVersion(event, object: any, isTitle){
    if(event.value){
      let moduleObj = {};
      moduleObj['version_label'] = isTitle ? event.value : object.version_label;
      moduleObj['release_date'] = !isTitle ? event.value : object.release_date;
      this.projectsService.editVersion(this.projectId, object.id, moduleObj).subscribe(
        res => {
          this.inlineEditorService.setValue(event);
          this.alertService.success({title: "SUCCESS", msg: "Successfully Updated"});
          this.loadProjectVersions();
        },
        error=>{
          event.value = isTitle ? object.version_label : object.release_date;
          this.inlineEditorService.setValue(event);
        }
      );
    }else{
      event.value = isTitle ? object.version_label : object.release_date;
      this.inlineEditorService.setValue(event);
      this.alertService.error({title: "ERROR", msg: isTitle ? "Title is Required" : "Related Date is Required"});
    }
  }

  onDelete(res) {

  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-delete-version.component.ts